import { REPORT_TYPES } from '@repo/constants'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/_app/reports/salesforce')({
  staticData: {
    title: REPORT_TYPES.SALESFORCE,
    crumb: REPORT_TYPES.SALESFORCE,
    permissions: ['reports_view_salesforce'],
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
